import React, { useState } from "react";
import styles from "./rejectReasonModal.module.css";

const RejectReasonModal = ({ onClose, onSave }) => {
  const [reason, setReason] = useState("");

  const handleSave = () => {
    if (reason.trim()) {
      onSave(reason);
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.header}>
          <div className={styles.title}>Reason for Rejection</div>
          <span className={styles.closeIcon} onClick={onClose}>
            <img src="/closeIcon.svg" alt="close" />
          </span>
        </div>

        <textarea
          className={styles.textarea}
          placeholder="Write reason for reject..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
        />

        <div className={styles.footer}>
          <button
            className={styles.cancelBtn}
            onClick={handleSave}
            disabled={!reason.trim()}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectReasonModal;
